import { useEffect, useState } from "react";
import Container from "../container";
import logo from ".././../assets/images/logo.svg";
import MobileToggleBtn from "./mobile_toggle_btn";

export default function Header({isOpen, toggleSidebar}) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const section2 = document.getElementById("section2");
            if (section2) {
                const rect = section2.getBoundingClientRect();
                setIsVisible(rect.top <= 0); 
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    
    return (
        <div className={`w-full bg-white h-[70px] transition-all duration-300 ${isVisible ? "fixed top-0 left-0 shadow-sm z-50" : "hidden"}`}>
            <Container>
                <div className="flex h-[70px] w-full justify-between items-center">
                    <img src={logo} alt="logo" width={140} height={49} />
                    <div className="hidden sm:flex items-center gap-[39px] pt-[24px]">
                        <div className="flex flex-col w-max group"
                            onClick={() => {
                                const element = document.getElementById("what-we-do");
                                const offset = 50;

                                if (element) {
                                    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                                    window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
                                }
                            }}
                        >
                            <h3 className="text-[#000] font-bold text-[15px] uppercase cursor-pointer pb-5 group-hover:text-[#8C4E8C] transition-colors duration-300">
                                What we do
                            </h3>
                            <div className="h-[4px] w-full bg-[#8C4E8C] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        </div>

                        <div className="flex flex-col w-max group"
                            onClick={() => {
                                const element = document.getElementById("vacancies");
                                const offset = 80;

                                if (element) {
                                    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                                    window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
                                }
                            }}
                        >
                            <h3 className="text-[#000] font-bold text-[15px] uppercase cursor-pointer pb-5 group-hover:text-[#8C4E8C] transition-colors duration-300">
                                Vacancies
                            </h3>
                            <div className="h-[4px] w-full bg-[#8C4E8C] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        </div>

                        <div className="flex flex-col w-max group"

                            onClick={() => document.getElementById('contacts').scrollIntoView({ behavior: "smooth", duration: 500 })}
                        >
                            <h3 className="text-[#000] font-bold text-[15px] uppercase cursor-pointer pb-5 group-hover:text-[#8C4E8C] transition-colors duration-300">
                                Contacts
                            </h3>
                            <div className="h-[4px] w-full bg-[#8C4E8C] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        </div>
                    </div>
                    <MobileToggleBtn
                        toggleSidebar={toggleSidebar}
                        isOpen={isOpen}
                    />
                </div>
                    
            </Container>
        </div>
    );
}
